// extracted by mini-css-extract-plugin
export default {"title":"styles_title__SiJ3v","icon":"styles_icon__BO40Y","titleDarkTheme":"styles_titleDarkTheme__p1qR3"};